const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Types of Triangles ────────────────────────────────
function DiagramTypes() {
  const W = 900, H = 320;
  const PW = (W - 7*10) / 6;

  const tri = (pts, fill, stroke) =>
    <polygon points={pts.map(p=>p.join(',')).join(' ')} fill={fill} fillOpacity="0.45" stroke={stroke} strokeWidth="2.2"/>;

  const label = (x, y, txt, color, size=12) =>
    <text x={x} y={y} textAnchor="middle" fontSize={size} fill={color} fontWeight="700">{txt}</text>;

  // Each panel: centre x, triangle vertices relative to panel
  const panels = [
    { title:'Equilateral', sub:'All sides equal, all angles 60°',
      color:'#2E75B6', fill:'#d0e8ff',
      verts: (cx,by) => [[cx, by-110],[cx-75,by],[cx+75,by]],
      extra: (cx,by) => <>
        {label(cx, by+16, 'a', '#2E75B6')}
        {label(cx-62, by-52, 'a', '#2E75B6')}
        {label(cx+62, by-52, 'a', '#2E75B6')}
        {label(cx-22, by-38, '60°', '#c0392b', 10)}
        {label(cx+20, by-38, '60°', '#c0392b', 10)}
        {label(cx, by-96, '60°', '#c0392b', 10)}
      </>
    },
    { title:'Isosceles', sub:'Two equal sides & angles',
      color:'#27ae60', fill:'#d0f0d8',
      verts: (cx,by) => [[cx, by-105],[cx-60,by],[cx+60,by]],
      extra: (cx,by) => <>
        {label(cx, by+16, 'b', '#27ae60')}
        {label(cx-52, by-50, 'a', '#27ae60')}
        {label(cx+52, by-50, 'a', '#27ae60')}
        <text x={cx-10} y={by-18} fontSize="10" fill="#c0392b" fontWeight="700">β</text>
        <text x={cx+4} y={by-18} fontSize="10" fill="#c0392b" fontWeight="700">β</text>
      </>
    },
    { title:'Scalene', sub:'All sides & angles different',
      color:'#9b59b6', fill:'#f5d0ff',
      verts: (cx,by) => [[cx-10, by-100],[cx-70,by],[cx+75,by]],
      extra: (cx,by) => <>
        {label(cx-50, by+16, 'c', '#9b59b6')}
        {label(cx-54, by-50, 'b', '#9b59b6')}
        {label(cx+35, by-52, 'a', '#9b59b6')}
      </>
    },
    { title:'Right', sub:'One angle = 90°',
      color:'#c0392b', fill:'#fde8e8',
      verts: (cx,by) => [[cx-65,by-100],[cx-65,by],[cx+65,by]],
      extra: (cx,by) => <>
        <rect x={cx-65} y={by-18} width={14} height={14} fill="none" stroke="#c0392b" strokeWidth="1.8"/>
        {label(cx, by+16, 'a', '#c0392b')}
        {label(cx-80, by-50, 'b', '#c0392b')}
        {label(cx+8, by-52, 'c', '#c0392b')}
        {label(cx-50, by-80, '90°', '#c0392b', 10)}
      </>
    },
    { title:'Obtuse', sub:'One angle > 90°',
      color:'#e07b00', fill:'#fff0cc',
      verts: (cx,by) => [[cx+55, by-85],[cx-80,by],[cx+75,by]],
      extra: (cx,by) => <>
        {label(cx-4, by+16, 'c', '#e07b00')}
        {label(cx-28, by-44, 'b', '#e07b00')}
        {label(cx+72, by-44, 'a', '#e07b00')}
        {label(cx-64, by-14, '>', '#e07b00', 14)}
      </>
    },
    { title:'Acute', sub:'All angles < 90°',
      color:'#1F3864', fill:'#d0e8ff',
      verts: (cx,by) => [[cx, by-108],[cx-68,by],[cx+68,by]],
      extra: (cx,by) => <>
        {label(cx, by+16, 'a', '#1F3864')}
        {label(cx-58, by-52, 'b', '#1F3864')}
        {label(cx+58, by-52, 'c', '#1F3864')}
        {label(cx-20, by-22, '<90', '#1F3864', 9)}
        {label(cx+18, by-22, '<90', '#1F3864', 9)}
        {label(cx, by-94, '<90', '#1F3864', 9)}
      </>
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Classification of Triangles — By Sides and By Angles</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {panels.map((p, i) => {
          const x0 = 14 + i*(PW+10);
          const cx = x0 + PW/2;
          const by = 215;
          const verts = p.verts(cx, by);
          return (
            <g key={p.title}>
              <rect x={x0} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
              <text x={cx} y={26} textAnchor="middle" fontSize="13" fill="#1F3864" fontWeight="700">{p.title}</text>
              <text x={cx} y={39} textAnchor="middle" fontSize="10" fill="#888">{p.sub}</text>
              {tri(verts, p.fill, p.color)}
              {p.extra(cx, by)}
              <rect x={x0+4} y={260} width={PW-8} height={44} rx={3} fill={p.fill} stroke={p.color} strokeWidth="1"/>
              <text x={cx} y={276} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">{p.title}</text>
              <text x={cx} y={291} textAnchor="middle" fontSize="10" fill="#555">{p.sub}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Triangles are classified by sides (equilateral, isosceles, scalene) and independently by angles (acute, right, obtuse). A triangle can be both isosceles and obtuse, for example. The sum of interior angles is always 180°.</div>
    </div>
  );
}

// ── Diagram 2: Key Parts & Angle Sum ────────────────────────────
function DiagramParts() {
  const W = 900, H = 340;

  // Main triangle for anatomy
  const Ax = 120, Ay = 290, Bx = 480, By = 290, Cx = 300, Cy = 70;
  // side lengths
  const a = Math.sqrt((Bx-Cx)**2+(By-Cy)**2); // BC opposite A
  const b = Math.sqrt((Ax-Cx)**2+(Ay-Cy)**2); // AC opposite B
  const c = Math.sqrt((Ax-Bx)**2+(Ay-By)**2); // AB opposite C

  // angle bisectors of angles (for arc drawing)
  const angA = Math.atan2(Ay-Cy, Ax-Cx) - Math.atan2(Ay-By, Ax-Bx);
  const angB = Math.atan2(By-Ay, Bx-Ax) - Math.atan2(By-Cy, Bx-Cx);
  const angC = Math.atan2(Cy-Ay, Cx-Ax) - Math.atan2(Cy-By, Cx-Bx);

  // altitude from C to AB
  const footX = Ax + ((Cx-Ax)*(Bx-Ax)+(Cy-Ay)*(By-Ay))/(c*c)*(Bx-Ax);
  const footY = Ay + ((Cx-Ax)*(Bx-Ax)+(Cy-Ay)*(By-Ay))/(c*c)*(By-Ay);

  // Right panel: exterior angle
  const ex0 = 560;
  const eAx=620,eAy=280, eBx=820,eBy=280, eCx=720,eCy=110;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Triangle Anatomy — Vertices, Sides, Angles, Altitude, and Exterior Angles</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Main anatomy panel */}
        <rect x={10} y={10} width={530} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={275} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Triangle Parts &amp; Notation</text>

        {/* Triangle */}
        <polygon points={`${Ax},${Ay} ${Bx},${By} ${Cx},${Cy}`} fill="#d0e8ff" fillOpacity="0.35" stroke="#2E75B6" strokeWidth="2.2"/>

        {/* Side labels */}
        <text x={(Bx+Cx)/2+12} y={(By+Cy)/2} fontSize="15" fill="#c0392b" fontWeight="700">a</text>
        <text x={(Ax+Cx)/2-20} y={(Ay+Cy)/2} fontSize="15" fill="#27ae60" fontWeight="700">b</text>
        <text x={(Ax+Bx)/2} y={Ay+18} fontSize="15" fill="#9b59b6" fontWeight="700">c</text>

        {/* Vertex labels */}
        <text x={Ax-18} y={Ay+4} fontSize="17" fill="#1F3864" fontWeight="700">A</text>
        <text x={Bx+8} y={By+4} fontSize="17" fill="#1F3864" fontWeight="700">B</text>
        <text x={Cx-4} y={Cy-10} fontSize="17" fill="#1F3864" fontWeight="700">C</text>

        {/* Angle arcs */}
        <path d="M 148,290 A 28 28 0 0 1 136,265" fill="none" stroke="#c0392b" strokeWidth="1.8"/>
        <text x={150} y={272} fontSize="13" fill="#c0392b" fontWeight="700">A</text>
        <path d="M 455,290 A 28 28 0 0 0 469,265" fill="none" stroke="#27ae60" strokeWidth="1.8"/>
        <text x={448} y={272} fontSize="13" fill="#27ae60" fontWeight="700">B</text>
        <path d="M 278,88 A 22 22 0 0 1 320,88" fill="none" stroke="#9b59b6" strokeWidth="1.8"/>
        <text x={298} y={110} fontSize="13" fill="#9b59b6" fontWeight="700">C</text>

        {/* Altitude */}
        <line x1={Cx} y1={Cy} x2={footX} y2={footY} stroke="#e07b00" strokeWidth="1.8" strokeDasharray="6,3"/>
        <rect x={footX-10} y={footY-10} width={11} height={11} fill="none" stroke="#e07b00" strokeWidth="1.5"/>
        <text x={Cx+8} y={(Cy+footY)/2} fontSize="12" fill="#e07b00" fontWeight="700">h</text>
        <text x={footX+14} y={footY+4} fontSize="11" fill="#e07b00">altitude foot</text>

        {/* Angle sum box */}
        <rect x={20} y={268} width={240} height={50} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={284} fontSize="13" fill="#1F3864" fontWeight="700">Angle sum theorem:</text>
        <text x={26} y={300} fontSize="13" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">A + B + C = 180°</text>
        <text x={26} y={313} fontSize="11" fill="#555">True for every triangle in Euclidean geometry</text>

        {/* Right panel: exterior angle */}
        <rect x={ex0} y={10} width={W-ex0-10} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={ex0+(W-ex0-10)/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Exterior Angle Theorem</text>

        <polygon points={`${eAx},${eAy} ${eBx},${eBy} ${eCx},${eCy}`} fill="#d0e8ff" fillOpacity="0.35" stroke="#2E75B6" strokeWidth="2.2"/>
        <text x={eAx-18} y={eAy+4} fontSize="15" fill="#1F3864" fontWeight="700">A</text>
        <text x={eBx+8} y={eBy+4} fontSize="15" fill="#1F3864" fontWeight="700">B</text>
        <text x={eCx-4} y={eCy-10} fontSize="15" fill="#1F3864" fontWeight="700">C</text>

        {/* Extend AB beyond B */}
        <line x1={eBx} y1={eBy} x2={eBx+90} y2={eBy} stroke="#c0392b" strokeWidth="2" strokeDasharray="6,3"/>
        <text x={eBx+95} y={eBy+4} fontSize="13" fill="#c0392b" fontWeight="700">D</text>

        {/* Exterior angle arc */}
        <path d="M 840,280 A 34 34 0 0 0 835,248" fill="none" stroke="#c0392b" strokeWidth="2"/>
        <text x={848} y={266} fontSize="13" fill="#c0392b" fontWeight="700">ext∠</text>

        {/* Interior angles at A and C */}
        <path d="M 648,280 A 22 22 0 0 1 639,261" fill="none" stroke="#27ae60" strokeWidth="1.8"/>
        <text x={650} y={268} fontSize="12" fill="#27ae60" fontWeight="700">α</text>
        <path d="M 708,118 A 20 20 0 0 1 730,118" fill="none" stroke="#9b59b6" strokeWidth="1.8"/>
        <text x={717} y={136} fontSize="12" fill="#9b59b6" fontWeight="700">γ</text>

        <rect x={ex0+6} y={248} width={W-ex0-22} height={72} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={ex0+12} y={264} fontSize="13" fill="#1F3864" fontWeight="700">Exterior angle = sum of remote interior angles</text>
        <text x={ex0+12} y={281} fontSize="13" fill="#c0392b" fontFamily="'Courier New',monospace" fontWeight="700">∠CBD = ∠A + ∠C</text>
        <text x={ex0+12} y={298} fontSize="11" fill="#555">Exterior angle is always greater than either remote interior angle</text>
        <text x={ex0+12} y={313} fontSize="11" fill="#555">Sum of all three exterior angles = 360°</text>
      </svg>
      <div style={S.dCaption}>The three vertices A, B, C give three sides (a opposite A, b opposite B, c opposite C) and three interior angles summing to 180°. The altitude h from C is perpendicular to AB. An exterior angle equals the sum of the two non-adjacent interior angles.</div>
    </div>
  );
}

// ── Diagram 3: Area Formulas ─────────────────────────────────────
function DiagramArea() {
  const W = 900, H = 330;

  // Panel 1: base × height
  const p1cx = 160, p1by = 230;
  const bAx=60,bAy=230, bBx=290,bBy=230, bCx=230,bCy=100;
  const bFx=230, bFy=230;

  // Panel 2: Heron's formula triangle
  const p2x = 320;
  const hAx=370,hAy=240, hBx=590,hBy=240, hCx=500,hCy=100;

  // Panel 3: SAS / trig area
  const p3x = 630;
  const tAx=660,tAy=240, tBx=870,tBy=240, tCx=760,tCy=100;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Area of a Triangle — Base×Height, Heron's Formula, and Trigonometric Form</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Panel 1: ½bh */}
        <rect x={10} y={10} width={300} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={160} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Base × Height</text>

        <polygon points={`${bAx},${bAy} ${bBx},${bBy} ${bCx},${bCy}`} fill="#d0e8ff" fillOpacity="0.4" stroke="#2E75B6" strokeWidth="2.2"/>

        {/* height */}
        <line x1={bCx} y1={bCy} x2={bFx} y2={bFy} stroke="#c0392b" strokeWidth="2" strokeDasharray="5,3"/>
        <rect x={bFx} y={bFy-12} width={12} height={12} fill="none" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={bFx+16} y={(bCy+bFy)/2+4} fontSize="14" fill="#c0392b" fontWeight="700">h</text>

        {/* base label */}
        <text x={(bAx+bBx)/2} y={bAy+18} textAnchor="middle" fontSize="14" fill="#2E75B6" fontWeight="700">b</text>

        {/* vertex labels */}
        <text x={bAx-16} y={bAy+4} fontSize="14" fill="#1F3864" fontWeight="700">A</text>
        <text x={bBx+6} y={bBy+4} fontSize="14" fill="#1F3864" fontWeight="700">B</text>
        <text x={bCx-4} y={bCy-10} fontSize="14" fill="#1F3864" fontWeight="700">C</text>

        <rect x={18} y={258} width={284} height={54} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={24} y={275} fontSize="13" fill="#1F3864" fontWeight="700">Area = ½ × base × height</text>
        <text x={24} y={292} fontSize="13" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">A = ½bh</text>
        <text x={24} y={306} fontSize="11" fill="#555">h ⊥ base; h may fall outside triangle (obtuse)</text>

        {/* Panel 2: Heron's */}
        <rect x={p2x} y={10} width={300} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={p2x+150} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Heron's Formula</text>

        <polygon points={`${hAx},${hAy} ${hBx},${hBy} ${hCx},${hCy}`} fill="#d0f0d8" fillOpacity="0.4" stroke="#27ae60" strokeWidth="2.2"/>
        <text x={(hBx+hCx)/2+12} y={(hBy+hCy)/2} fontSize="14" fill="#27ae60" fontWeight="700">a</text>
        <text x={(hAx+hCx)/2-18} y={(hAy+hCy)/2} fontSize="14" fill="#27ae60" fontWeight="700">b</text>
        <text x={(hAx+hBx)/2} y={hAy+18} textAnchor="middle" fontSize="14" fill="#27ae60" fontWeight="700">c</text>
        <text x={hAx-16} y={hAy+4} fontSize="14" fill="#1F3864" fontWeight="700">A</text>
        <text x={hBx+6} y={hBy+4} fontSize="14" fill="#1F3864" fontWeight="700">B</text>
        <text x={hCx-4} y={hCy-10} fontSize="14" fill="#1F3864" fontWeight="700">C</text>

        <rect x={p2x+8} y={258} width={284} height={54} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={p2x+14} y={275} fontSize="12" fill="#1F3864" fontWeight="700">s = (a+b+c)/2  (semi-perimeter)</text>
        <text x={p2x+14} y={292} fontSize="13" fill="#27ae60" fontFamily="'Courier New',monospace" fontWeight="700">A = √(s(s−a)(s−b)(s−c))</text>
        <text x={p2x+14} y={306} fontSize="11" fill="#555">Uses only side lengths — no height needed</text>

        {/* Panel 3: SAS trig */}
        <rect x={p3x} y={10} width={260} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={p3x+130} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">SAS Trigonometric</text>

        <polygon points={`${tAx},${tAy} ${tBx},${tBy} ${tCx},${tCy}`} fill="#fff0cc" fillOpacity="0.5" stroke="#e07b00" strokeWidth="2.2"/>
        <text x={(tBx+tCx)/2+12} y={(tBy+tCy)/2} fontSize="14" fill="#e07b00" fontWeight="700">a</text>
        <text x={(tAx+tCx)/2-18} y={(tAy+tCy)/2} fontSize="14" fill="#e07b00" fontWeight="700">b</text>
        <text x={(tAx+tBx)/2} y={tAy+18} textAnchor="middle" fontSize="14" fill="#e07b00" fontWeight="700">c</text>
        <text x={tAx-16} y={tAy+4} fontSize="14" fill="#1F3864" fontWeight="700">A</text>
        <text x={tBx+6} y={tBy+4} fontSize="14" fill="#1F3864" fontWeight="700">B</text>
        <text x={tCx-4} y={tCy-10} fontSize="14" fill="#1F3864" fontWeight="700">C</text>
        {/* angle arc at A */}
        <path d="M 684,240 A 24 24 0 0 1 676,219" fill="none" stroke="#c0392b" strokeWidth="1.8"/>
        <text x={688} y={228} fontSize="12" fill="#c0392b" fontWeight="700">C</text>

        <rect x={p3x+6} y={258} width={248} height={54} rx={3} fill="#fff7ee" stroke="#e07b00" strokeWidth="1"/>
        <text x={p3x+12} y={275} fontSize="12" fill="#1F3864" fontWeight="700">Two sides + included angle</text>
        <text x={p3x+12} y={292} fontSize="12" fill="#e07b00" fontFamily="'Courier New',monospace" fontWeight="700">A = ½ab sin C</text>
        <text x={p3x+12} y={306} fontSize="11" fill="#555">Also: ½bc sin A = ½ac sin B</text>
      </svg>
      <div style={S.dCaption}>Three methods for area: ½bh needs a known height; Heron's formula needs only the three side lengths via the semi-perimeter s=(a+b+c)/2; the SAS form ½ab sin C needs two sides and their included angle. All three give the same result.</div>
    </div>
  );
}

// ── Diagram 4: Sine & Cosine Rules ──────────────────────────────
function DiagramSineCosine() {
  const W = 900, H = 340;

  // Shared triangle for both rules
  const Ax=90, Ay=270, Bx=370, By=270, Cx=250, Cy=80;

  // Circumradius for sine rule
  const sideA = Math.sqrt((Bx-Cx)**2+(By-Cy)**2);
  const sideB = Math.sqrt((Ax-Cx)**2+(Ay-Cy)**2);
  const sideC = Math.sqrt((Ax-Bx)**2+(Ay-By)**2);
  const areaVal = 0.5*Math.abs((Bx-Ax)*(Cy-Ay)-(Cx-Ax)*(By-Ay));
  const R = (sideA*sideB*sideC)/(4*areaVal);
  // circumcentre
  const D = 2*(Ax*(By-Cy)+Bx*(Cy-Ay)+Cx*(Ay-By));
  const ux = ((Ax**2+Ay**2)*(By-Cy)+(Bx**2+By**2)*(Cy-Ay)+(Cx**2+Cy**2)*(Ay-By))/D;
  const uy = ((Ax**2+Ay**2)*(Cx-Bx)+(Bx**2+By**2)*(Ax-Cx)+(Cx**2+Cy**2)*(Bx-Ax))/D;

  // Right panel: cosine rule triangle
  const cAx=530, cAy=270, cBx=820, cBy=270, cCx=640, cCy=90;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Sine Rule and Cosine Rule — Solving Any Triangle</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Sine rule panel */}
        <rect x={10} y={10} width={460} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={240} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">The Sine Rule</text>

        {/* Circumscribed circle */}
        <circle cx={ux} cy={uy} r={R} fill="none" stroke="#e07b00" strokeWidth="1.4" strokeDasharray="5,3"/>
        {/* radii to vertices */}
        <line x1={ux} y1={uy} x2={Ax} y2={Ay} stroke="#e07b00" strokeWidth="1" opacity="0.4"/>
        <line x1={ux} y1={uy} x2={Bx} y2={By} stroke="#e07b00" strokeWidth="1" opacity="0.4"/>
        <line x1={ux} y1={uy} x2={Cx} y2={Cy} stroke="#e07b00" strokeWidth="1" opacity="0.4"/>
        <circle cx={ux} cy={uy} r={4} fill="#e07b00"/>
        <text x={ux+6} y={uy-6} fontSize="11" fill="#e07b00" fontWeight="700">O (circumcentre)</text>
        <text x={ux-50} y={uy+R-16} fontSize="11" fill="#e07b00" fontWeight="700">R</text>

        {/* Triangle */}
        <polygon points={`${Ax},${Ay} ${Bx},${By} ${Cx},${Cy}`} fill="#d0e8ff" fillOpacity="0.4" stroke="#2E75B6" strokeWidth="2.2"/>
        <text x={Ax-18} y={Ay+4} fontSize="15" fill="#1F3864" fontWeight="700">A</text>
        <text x={Bx+8} y={By+4} fontSize="15" fill="#1F3864" fontWeight="700">B</text>
        <text x={Cx-4} y={Cy-10} fontSize="15" fill="#1F3864" fontWeight="700">C</text>
        <text x={(Bx+Cx)/2+12} y={(By+Cy)/2} fontSize="14" fill="#c0392b" fontWeight="700">a</text>
        <text x={(Ax+Cx)/2-18} y={(Ay+Cy)/2} fontSize="14" fill="#27ae60" fontWeight="700">b</text>
        <text x={(Ax+Bx)/2} y={Ay+18} textAnchor="middle" fontSize="14" fill="#9b59b6" fontWeight="700">c</text>

        {/* angle arcs */}
        <path d="M 116,270 A 26 26 0 0 1 107,248" fill="none" stroke="#c0392b" strokeWidth="1.8"/>
        <text x={122} y={258} fontSize="13" fill="#c0392b" fontWeight="700">A</text>
        <path d="M 345,270 A 26 26 0 0 0 358,249" fill="none" stroke="#9b59b6" strokeWidth="1.8"/>
        <text x={338} y={257} fontSize="13" fill="#9b59b6" fontWeight="700">B</text>
        <path d="M 233,87 A 20 20 0 0 1 266,87" fill="none" stroke="#27ae60" strokeWidth="1.8"/>
        <text x={248} y={107} fontSize="13" fill="#27ae60" fontWeight="700">C</text>

        <rect x={18} y={280} width={444} height={44} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={24} y={296} fontSize="13" fill="#1F3864" fontWeight="700">Sine Rule:  a/sin A = b/sin B = c/sin C = 2R</text>
        <text x={24} y={314} fontSize="11" fill="#555">Use when: AAS, ASA, or SSA (ambiguous case) is given</text>

        {/* Cosine rule panel */}
        <rect x={480} y={10} width={410} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={685} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">The Cosine Rule</text>

        <polygon points={`${cAx},${cAy} ${cBx},${cBy} ${cCx},${cCy}`} fill="#d0f0d8" fillOpacity="0.4" stroke="#27ae60" strokeWidth="2.2"/>
        <text x={cAx-18} y={cAy+4} fontSize="15" fill="#1F3864" fontWeight="700">A</text>
        <text x={cBx+8} y={cBy+4} fontSize="15" fill="#1F3864" fontWeight="700">B</text>
        <text x={cCx-4} y={cCy-10} fontSize="15" fill="#1F3864" fontWeight="700">C</text>
        <text x={(cBx+cCx)/2+12} y={(cBy+cCy)/2} fontSize="14" fill="#c0392b" fontWeight="700">a</text>
        <text x={(cAx+cCx)/2-18} y={(cAy+cCy)/2} fontSize="14" fill="#27ae60" fontWeight="700">b</text>
        <text x={(cAx+cBx)/2} y={cAy+18} textAnchor="middle" fontSize="14" fill="#9b59b6" fontWeight="700">c</text>

        {/* angle arc at A */}
        <path d="M 556,270 A 26 26 0 0 1 548,248" fill="none" stroke="#c0392b" strokeWidth="1.8"/>
        <text x={562} y={256} fontSize="13" fill="#c0392b" fontWeight="700">A</text>

        {/* projection lines to show cosine rule derivation */}
        {(()=>{
          const footX = cAx + ((cCx-cAx)*(cBx-cAx)+(cCy-cAy)*(cBy-cAy))/((cBx-cAx)**2+(cBy-cAy)**2)*(cBx-cAx);
          const footY = cAy + ((cCx-cAx)*(cBx-cAx)+(cCy-cAy)*(cBy-cAy))/((cBx-cAx)**2+(cBy-cAy)**2)*(cBy-cAy);
          return <>
            <line x1={cCx} y1={cCy} x2={footX} y2={footY} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="4,3"/>
            <rect x={footX-10} y={footY-10} width={10} height={10} fill="none" stroke="#e07b00" strokeWidth="1.3"/>
            <text x={footX+6} y={footY-2} fontSize="11" fill="#e07b00">h</text>
          </>;
        })()}

        <rect x={488} y={268} width={394} height={54} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={494} y={284} fontSize="13" fill="#1F3864" fontWeight="700">Cosine Rule:  a² = b² + c² − 2bc cos A</text>
        <text x={494} y={300} fontSize="12" fill="#27ae60" fontFamily="'Courier New',monospace">cos A = (b²+c²−a²) / (2bc)</text>
        <text x={494} y={315} fontSize="11" fill="#555">Use when: SAS or SSS is given. Reduces to Pythagoras when A=90°</text>
      </svg>
      <div style={S.dCaption}>The sine rule connects sides to opposite angles via the circumradius R. The cosine rule generalises Pythagoras to any triangle and is used when two sides and the included angle are known (SAS) or all three sides are known (SSS). Together these two rules can solve any triangle.</div>
    </div>
  );
}

// ── Diagram 5: Special Lines & Centres ──────────────────────────
function DiagramCentres() {
  const W = 900, H = 350;

  // Shared triangle shape
  const mkTri = (ox, oy, sc) => {
    const A = [ox - 80*sc, oy + 65*sc];
    const B = [ox + 90*sc, oy + 65*sc];
    const C = [ox + 10*sc, oy - 90*sc];
    return { A, B, C };
  };

  const sc = 0.72;

  // Panel offsets
  const panels = [
    { label:'Centroid', color:'#2E75B6', ox:112, oy:175 },
    { label:'Circumcentre', color:'#c0392b', ox:335, oy:175 },
    { label:'Incentre', color:'#27ae60', ox:558, oy:175 },
    { label:'Orthocentre', color:'#9b59b6', ox:781, oy:175 },
  ];
  const PW = 210;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Four Triangle Centres — Centroid, Circumcentre, Incentre, Orthocentre</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {panels.map((p, idx) => {
          const x0 = 10 + idx*(PW+8);
          const {A,B,C} = mkTri(p.ox, p.oy, sc);
          const [Ax,Ay]=A,[Bx,By]=B,[Cx,Cy]=C;

          // Midpoints
          const MABx=(Ax+Bx)/2, MABy=(Ay+By)/2;
          const MBCx=(Bx+Cx)/2, MBCy=(By+Cy)/2;
          const MACx=(Ax+Cx)/2, MACy=(Ay+Cy)/2;

          // Centroid
          const Gx=(Ax+Bx+Cx)/3, Gy=(Ay+By+Cy)/3;

          // Circumcentre
          const D=2*(Ax*(By-Cy)+Bx*(Cy-Ay)+Cx*(Ay-By));
          const Ox=((Ax**2+Ay**2)*(By-Cy)+(Bx**2+By**2)*(Cy-Ay)+(Cx**2+Cy**2)*(Ay-By))/D;
          const Oy=((Ax**2+Ay**2)*(Cx-Bx)+(Bx**2+By**2)*(Ax-Cx)+(Cx**2+Cy**2)*(Bx-Ax))/D;
          const Rcirc=Math.sqrt((Ox-Ax)**2+(Oy-Ay)**2);

          // Incentre
          const a=Math.sqrt((Bx-Cx)**2+(By-Cy)**2);
          const b=Math.sqrt((Ax-Cx)**2+(Ay-Cy)**2);
          const c=Math.sqrt((Ax-Bx)**2+(Ay-By)**2);
          const Ix=(a*Ax+b*Bx+c*Cx)/(a+b+c);
          const Iy=(a*Ay+b*By+c*Cy)/(a+b+c);
          const s=(a+b+c)/2;
          const area=Math.abs((Bx-Ax)*(Cy-Ay)-(Cx-Ax)*(By-Ay))/2;
          const Rincircle=area/s;

          // Orthocentre (intersection of altitudes)
          // altitude from A perpendicular to BC
          const bcDx=Cx-Bx, bcDy=Cy-By;
          const acDx=Cx-Ax, acDy=Cy-Ay;
          // solve: A + t*(perp to BC) intersects B + s*(perp to AC)
          const perpBC = [-bcDy, bcDx];
          const perpAC = [-acDy, acDx];
          const denom = perpBC[0]*(-perpAC[1]) - perpBC[1]*(-perpAC[0]);
          const tH = ((Bx-Ax)*(-perpAC[1])-(By-Ay)*(-perpAC[0]))/denom;
          const Hx = Ax + tH*perpBC[0];
          const Hy = Ay + tH*perpBC[1];

          // foot of altitude from A to BC
          const tAfoot = ((Ax-Bx)*bcDx+(Ay-By)*bcDy)/(bcDx**2+bcDy**2);
          const AfootX = Bx + tAfoot*bcDx, AfootY = By + tAfoot*bcDy;
          // foot from B to AC
          const tBfoot = ((Bx-Ax)*acDx+(By-Ay)*acDy)/(acDx**2+acDy**2);
          const BfootX = Ax + tBfoot*acDx, BfootY = Ay + tBfoot*acDy;

          return (
            <g key={p.label}>
              <rect x={x0} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
              <text x={x0+PW/2} y={26} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">{p.label}</text>

              {/* Base triangle */}
              <polygon points={`${Ax},${Ay} ${Bx},${By} ${Cx},${Cy}`} fill={p.color} fillOpacity="0.1" stroke={p.color} strokeWidth="1.8"/>

              {/* ── Centroid ── */}
              {idx===0 && <>
                <line x1={Ax} y1={Ay} x2={MBCx} y2={MBCy} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="5,3"/>
                <line x1={Bx} y1={By} x2={MACx} y2={MACy} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="5,3"/>
                <line x1={Cx} y1={Cy} x2={MABx} y2={MABy} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="5,3"/>
                <circle cx={MBCx} cy={MBCy} r={3} fill="#2E75B6"/>
                <circle cx={MACx} cy={MACy} r={3} fill="#2E75B6"/>
                <circle cx={MABx} cy={MABy} r={3} fill="#2E75B6"/>
                <circle cx={Gx} cy={Gy} r={6} fill="#2E75B6" stroke="#fff" strokeWidth="2"/>
                <text x={Gx+8} y={Gy-6} fontSize="12" fill="#2E75B6" fontWeight="700">G</text>
                <rect x={x0+6} y={278} width={PW-12} height={58} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
                <text x={x0+10} y={293} fontSize="11" fill="#1F3864" fontWeight="700">Intersection of medians</text>
                <text x={x0+10} y={308} fontSize="10" fill="#555" fontFamily="'Courier New',monospace">G = ((x₁+x₂+x₃)/3,</text>
                <text x={x0+10} y={321} fontSize="10" fill="#555" fontFamily="'Courier New',monospace">     (y₁+y₂+y₃)/3)</text>
                <text x={x0+10} y={330} fontSize="10" fill="#555">Divides each median 2:1</text>
              </>}

              {/* ── Circumcentre ── */}
              {idx===1 && <>
                <circle cx={Ox} cy={Oy} r={Rcirc} fill="none" stroke="#e07b00" strokeWidth="1.4" strokeDasharray="5,3"/>
                {/* perp bisectors */}
                {[[MABx,MABy,Ax,Ay,Bx,By],[MBCx,MBCy,Bx,By,Cx,Cy],[MACx,MACy,Ax,Ay,Cx,Cy]].map(([mx,my,p1x,p1y,p2x,p2y],i)=>{
                  const dx=p2x-p1x,dy=p2y-p1y,len=Math.sqrt(dx*dx+dy*dy);
                  const px=-dy/len*60,py=dx/len*60;
                  return <line key={i} x1={mx-px} y1={my-py} x2={mx+px} y2={my+py} stroke="#c0392b" strokeWidth="1.4" strokeDasharray="4,3"/>;
                })}
                <circle cx={Ox} cy={Oy} r={6} fill="#c0392b" stroke="#fff" strokeWidth="2"/>
                <text x={Ox+8} y={Oy-6} fontSize="12" fill="#c0392b" fontWeight="700">O</text>
                <rect x={x0+6} y={278} width={PW-12} height={58} rx={3} fill="#fde8e8" stroke="#c0392b" strokeWidth="1"/>
                <text x={x0+10} y={293} fontSize="11" fill="#1F3864" fontWeight="700">Intersection of perp. bisectors</text>
                <text x={x0+10} y={308} fontSize="10" fill="#555">Centre of circumscribed circle</text>
                <text x={x0+10} y={321} fontSize="10" fill="#555" fontFamily="'Courier New',monospace">R = abc/(4·Area)</text>
                <text x={x0+10} y={334} fontSize="10" fill="#555">Inside if acute, outside if obtuse</text>
              </>}

              {/* ── Incentre ── */}
              {idx===2 && <>
                {/* angle bisectors */}
                <line x1={Ax} y1={Ay} x2={Ix} y2={Iy} stroke="#27ae60" strokeWidth="1.4" strokeDasharray="5,3"/>
                <line x1={Bx} y1={By} x2={Ix} y2={Iy} stroke="#27ae60" strokeWidth="1.4" strokeDasharray="5,3"/>
                <line x1={Cx} y1={Cy} x2={Ix} y2={Iy} stroke="#27ae60" strokeWidth="1.4" strokeDasharray="5,3"/>
                {/* incircle */}
                <circle cx={Ix} cy={Iy} r={Rincircle} fill="#27ae60" fillOpacity="0.12" stroke="#27ae60" strokeWidth="1.6"/>
                <circle cx={Ix} cy={Iy} r={6} fill="#27ae60" stroke="#fff" strokeWidth="2"/>
                <text x={Ix+8} y={Iy-6} fontSize="12" fill="#27ae60" fontWeight="700">I</text>
                <rect x={x0+6} y={278} width={PW-12} height={58} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
                <text x={x0+10} y={293} fontSize="11" fill="#1F3864" fontWeight="700">Intersection of angle bisectors</text>
                <text x={x0+10} y={308} fontSize="10" fill="#555">Centre of inscribed circle</text>
                <text x={x0+10} y={321} fontSize="10" fill="#555" fontFamily="'Courier New',monospace">r = Area / s</text>
                <text x={x0+10} y={334} fontSize="10" fill="#555">Always inside the triangle</text>
              </>}

              {/* ── Orthocentre ── */}
              {idx===3 && <>
                <line x1={Ax} y1={Ay} x2={AfootX} y2={AfootY} stroke="#9b59b6" strokeWidth="1.4" strokeDasharray="5,3"/>
                <line x1={Bx} y1={By} x2={BfootX} y2={BfootY} stroke="#9b59b6" strokeWidth="1.4" strokeDasharray="5,3"/>
                <rect x={AfootX-8} y={AfootY-8} width={9} height={9} fill="none" stroke="#9b59b6" strokeWidth="1.2"/>
                <rect x={BfootX-8} y={BfootY-9} width={9} height={9} fill="none" stroke="#9b59b6" strokeWidth="1.2" transform={`rotate(${Math.atan2(acDy,acDx)*180/Math.PI},${BfootX},${BfootY})`}/>
                <circle cx={Hx} cy={Hy} r={6} fill="#9b59b6" stroke="#fff" strokeWidth="2"/>
                <text x={Hx+8} y={Hy-6} fontSize="12" fill="#9b59b6" fontWeight="700">H</text>
                <rect x={x0+6} y={278} width={PW-12} height={58} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
                <text x={x0+10} y={293} fontSize="11" fill="#1F3864" fontWeight="700">Intersection of altitudes</text>
                <text x={x0+10} y={308} fontSize="10" fill="#555">Altitudes are perpendicular to sides</text>
                <text x={x0+10} y={321} fontSize="10" fill="#555">Inside if acute, on hyp. if right</text>
                <text x={x0+10} y={334} fontSize="10" fill="#555">Outside if obtuse</text>
              </>}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Every triangle has four classic centres. The centroid G divides each median 2:1 and is the centre of mass. The circumcentre O is equidistant from all vertices. The incentre I is equidistant from all sides. The orthocentre H is where the three altitudes meet. All four are collinear on the Euler line (for non-equilateral triangles).</div>
    </div>
  );
}

// ── Diagram 6: Similar & Congruent Triangles ─────────────────────
function DiagramSimilarCongruent() {
  const W = 900, H = 300;

  // Left: congruence conditions
  const condX = 14;
  const condW = 380;

  // Right: similar triangles with proportions
  const simX = 410;
  const simW = W - simX - 14;

  // Small triangle
  const sAx=440,sAy=260, sBx=560,sBy=260, sCx=490,sCy=150;
  // Large triangle (scale 1.5)
  const sc = 1.45;
  const lAx=580,lAy=260, lBx=580+(560-440)*sc,lBy=260, lCx=580+(490-440)*sc,lCy=260-(260-150)*sc;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Congruence and Similarity — Conditions, Corresponding Parts, and Scale Factors</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Congruence conditions */}
        <rect x={condX} y={10} width={condW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={condX+condW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Congruence Conditions (≅)</text>
        <text x={condX+condW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">Triangles identical in shape and size</text>

        {[
          {y:54,  label:'SSS', desc:'Three sides equal',                     color:'#2E75B6', bg:'#EBF3FB'},
          {y:100, label:'SAS', desc:'Two sides and included angle equal',     color:'#27ae60', bg:'#f0fff4'},
          {y:146, label:'ASA', desc:'Two angles and included side equal',     color:'#c0392b', bg:'#fde8e8'},
          {y:192, label:'AAS', desc:'Two angles and non-included side equal', color:'#9b59b6', bg:'#f5d0ff'},
          {y:238, label:'RHS', desc:'Right angle, hypotenuse, one side',      color:'#e07b00', bg:'#fff7ee'},
        ].map(({y,label,desc,color,bg})=>(
          <g key={label}>
            <rect x={condX+8} y={y} width={condW-16} height={38} rx={3} fill={bg} stroke={color} strokeWidth="1.2"/>
            <rect x={condX+10} y={y+2} width={40} height={34} rx={2} fill={color}/>
            <text x={condX+30} y={y+23} textAnchor="middle" fontSize="14" fill="#fff" fontWeight="700">{label}</text>
            <text x={condX+60} y={y+17} fontSize="12" fill="#1F3864" fontWeight="700">{desc}</text>
          </g>
        ))}

        {/* Similarity panel */}
        <rect x={simX} y={10} width={simW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={simX+simW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Similar Triangles (~)</text>
        <text x={simX+simW/2} y={44} textAnchor="middle" fontSize="11" fill="#888">Same shape, different size — k = scale factor</text>

        {/* Small triangle */}
        <polygon points={`${sAx},${sAy} ${sBx},${sBy} ${sCx},${sCy}`} fill="#d0e8ff" fillOpacity="0.5" stroke="#2E75B6" strokeWidth="2"/>
        <text x={sAx-14} y={sAy+4} fontSize="12" fill="#1F3864" fontWeight="700">A</text>
        <text x={sBx+4} y={sBy+4} fontSize="12" fill="#1F3864" fontWeight="700">B</text>
        <text x={sCx-4} y={sCy-8} fontSize="12" fill="#1F3864" fontWeight="700">C</text>

        {/* Large triangle */}
        <polygon points={`${lAx},${lAy} ${lBx},${lBy} ${lCx},${lCy}`} fill="#fde8e8" fillOpacity="0.5" stroke="#c0392b" strokeWidth="2"/>
        <text x={lAx-14} y={lAy+4} fontSize="12" fill="#1F3864" fontWeight="700">A'</text>
        <text x={lBx+4} y={lBy+4} fontSize="12" fill="#1F3864" fontWeight="700">B'</text>
        <text x={lCx-4} y={lCy-8} fontSize="12" fill="#1F3864" fontWeight="700">C'</text>

        {/* Scale factor arrow */}
        <line x1={(sBx+sCx)/2+8} y1={(sBy+sCy)/2} x2={(lBx+lCx)/2-8} y2={(lBy+lCy)/2} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="4,3" markerEnd="url(#arr)"/>
        <text x={((sBx+sCx)/2+(lBx+lCx)/2)/2} y={(sBy+sCy)/2-10} textAnchor="middle" fontSize="12" fill="#e07b00" fontWeight="700">×k</text>

        {/* Proportion box */}
        <rect x={simX+8} y={228} width={simW-16} height={54} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={simX+14} y={244} fontSize="12" fill="#1F3864" fontWeight="700">Similarity conditions: AA, SAS~, SSS~</text>
        <text x={simX+14} y={260} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">AB/A'B' = BC/B'C' = AC/A'C' = k</text>
        <text x={simX+14} y={275} fontSize="11" fill="#555">Corresponding angles equal; areas scale by k²</text>
      </svg>
      <div style={S.dCaption}>Congruent triangles (≅) are identical — five conditions guarantee congruence, with SSA not being sufficient in general (ambiguous case). Similar triangles (~) have equal angles and proportional sides with scale factor k; their areas are in ratio k². The AA condition alone is sufficient for similarity.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function TriangleGeometry() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Triangle Geometry</h1>
      <p style={S.p}>The triangle is the simplest polygon and the foundation of all geometry. Every polygon can be triangulated; every structure in engineering, architecture, and computer graphics is ultimately built from triangles. Understanding their properties — angles, areas, special lines, and centres — is essential across mathematics and its applications.</p>

      <InfoBox title="Core Facts Every Triangle Satisfies" items={[
        "Angle sum: A + B + C = 180° — always, in Euclidean geometry",
        "Triangle inequality: each side < sum of the other two sides",
        "Exterior angle = sum of the two non-adjacent interior angles",
        "Largest side is opposite the largest angle (and vice versa)",
        "Sine rule: a/sin A = b/sin B = c/sin C = 2R  (R = circumradius)",
        "Cosine rule: a² = b² + c² − 2bc cos A  (generalises Pythagoras)",
        "Area = ½bh = ½ab sin C = √(s(s−a)(s−b)(s−c))",
      ]}/>

      <h2 style={S.h2}>Types of Triangles</h2>
      <DiagramTypes/>
      <Table2 rows={[
        ["Equilateral","All three sides equal, all angles = 60°\nHighest symmetry; also equiangular"],
        ["Isosceles","Exactly two equal sides and two equal base angles\nAxis of symmetry through apex and base midpoint"],
        ["Scalene","All three sides and angles different\nNo lines of symmetry"],
        ["Acute","All angles < 90°\nCircumcentre and orthocentre both inside triangle"],
        ["Right","One angle = 90°; Pythagoras applies: a²+b²=c²\nCircumcentre on hypotenuse; orthocentre at right-angle vertex"],
        ["Obtuse","One angle > 90°\nCircumcentre and orthocentre both outside triangle"],
      ]}/>

      <h2 style={S.h2}>Triangle Parts and Angle Relationships</h2>
      <DiagramParts/>
      <Table2 rows={[
        ["Angle sum","A + B + C = 180°\nUsed to find a third angle when two are known"],
        ["Exterior angle","= sum of two non-adjacent interior angles\nAlways greater than either remote interior angle"],
        ["Altitude (height)","Perpendicular distance from a vertex to opposite side\nMay fall outside the triangle for obtuse triangles"],
        ["Median","Line from vertex to midpoint of opposite side\nAll three meet at centroid G"],
        ["Angle bisector","Line from vertex bisecting the angle\nAll three meet at incentre I"],
        ["Perpendicular bisector","Bisects a side at 90°\nAll three meet at circumcentre O"],
        ["Midsegment","Line joining midpoints of two sides\nParallel to third side and half its length"],
      ]}/>

      <h2 style={S.h2}>Area of a Triangle</h2>
      <DiagramArea/>
      <Table2 rows={[
        ["Base × height","A = ½bh\nAny side can be the base; h is the perpendicular height"],
        ["Heron's formula","s = (a+b+c)/2;  A = √(s(s−a)(s−b)(s−c))\nNeeds only side lengths; useful when height is unknown"],
        ["SAS (trig) form","A = ½ab sin C = ½bc sin A = ½ac sin B\nNeeds two sides and their included angle"],
        ["Coordinate form","A = ½|x₁(y₂−y₃)+x₂(y₃−y₁)+x₃(y₁−y₂)|\nShoelace formula for vertices given as coordinates"],
        ["Equilateral triangle","A = (√3/4)a²  where a is the side length"],
        ["Right triangle","A = ½ × leg₁ × leg₂\nThe two legs are perpendicular, so h = one leg"],
      ]}/>

      <h2 style={S.h2}>The Sine Rule and Cosine Rule</h2>
      <DiagramSineCosine/>
      <Table2 rows={[
        ["Sine rule","a/sin A = b/sin B = c/sin C = 2R\nUse for AAS, ASA; be careful of ambiguous SSA case"],
        ["Ambiguous case (SSA)","Given two sides and non-included angle: may give 0, 1, or 2 triangles\nCheck: if b < a sin B → no solution; if b = a sin B → right triangle"],
        ["Cosine rule","a² = b²+c²−2bc cos A\nUse for SAS (find missing side) or SSS (find angle)"],
        ["Finding angle (cosine)","cos A = (b²+c²−a²) / (2bc)\nRearranged cosine rule; gives unique angle 0°<A<180°"],
        ["Circumradius R","R = a/(2 sin A) = abc/(4·Area)\nRadius of circle passing through all three vertices"],
        ["Inradius r","r = Area/s  where s = (a+b+c)/2\nRadius of circle tangent to all three sides"],
      ]}/>

      <h2 style={S.h2}>Special Lines and Triangle Centres</h2>
      <DiagramCentres/>
      <Table2 rows={[
        ["Centroid G","Intersection of the three medians\nG = ((x₁+x₂+x₃)/3, (y₁+y₂+y₃)/3); divides each median 2:1 from vertex"],
        ["Circumcentre O","Intersection of perpendicular bisectors of the sides\nCentre of circumscribed circle; R = abc/(4·Area)"],
        ["Incentre I","Intersection of the three angle bisectors\nCentre of inscribed circle; r = Area/s"],
        ["Orthocentre H","Intersection of the three altitudes\nInside (acute), on hypotenuse vertex (right), outside (obtuse)"],
        ["Euler line","G, O, H are collinear: OG:GH = 1:2\nTrue for all non-equilateral triangles"],
        ["Nine-point centre N","Midpoint of OH on the Euler line\nCircle through midpoints of sides, feet of altitudes, midpoints of AH/BH/CH"],
      ]}/>

      <h2 style={S.h2}>Similar and Congruent Triangles</h2>
      <DiagramSimilarCongruent/>
      <Table2 rows={[
        ["Congruence (≅)","SSS, SAS, ASA, AAS, RHS\nSSA is NOT a valid congruence condition in general"],
        ["Similarity (~)","AA (sufficient alone), SAS~, SSS~\nEqual angles + proportional sides"],
        ["Scale factor k","All corresponding lengths in ratio k\nAreas in ratio k²; volumes (3D) in ratio k³"],
        ["Basic proportionality","A line parallel to one side of a triangle divides the other two sides proportionally\n(Thales' intercept theorem)"],
        ["Angle bisector theorem","The bisector of angle A divides opposite side BC in ratio AB:AC\nBD/DC = c/b"],
        ["Similar triangles & area","If triangles ~ with scale k: Area₁/Area₂ = k²\nPerimeters in ratio k"],
      ]}/>

      <InfoBox title="Key Takeaway — Which Tool to Use for Each Triangle Problem" items={[
        "Find a missing angle? → Angle sum A+B+C=180°, or exterior angle theorem",
        "Find area with base & height? → A = ½bh",
        "Find area with three sides only? → Heron's formula: √(s(s−a)(s−b)(s−c))",
        "Find area with two sides and included angle? → A = ½ab sin C",
        "Solve triangle with AAS or ASA? → Sine rule: a/sin A = b/sin B = c/sin C",
        "Solve triangle with SAS or SSS? → Cosine rule: a²=b²+c²−2bc cos A",
        "Find centre of mass? → Centroid G = average of vertices",
        "Find circumscribed circle? → Circumcentre O, radius R=abc/(4·Area)",
        "Find inscribed circle? → Incentre I, radius r=Area/s",
      ]}/>
    </div>
  );
}